// extracted by mini-css-extract-plugin
export var textInput = "_kv-0";